import { useDispatch } from "react-redux";
import { deletePartner } from "../../../redux/CustomerReducer";
import Swal from "sweetalert2";
import { verifyAmbassador } from "../../../redux/CustomerReducer";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useState, useEffect } from "react";

export default function AmbassadorsVerifiedData(props) {
  const [deleteVeh, setDeleteVeh] = useState(0);
  const [Index, setIndex] = useState();
  const [flag, setFlag] = useState();
  const dispatch = useDispatch();
  const [alertIndex, setAlertIndex] = useState();


  let filtered = props.driverData?.filter(
    (item) =>
      item.verified === true &&
      item.verifieduser === true &&
      item.category === "ambassador"
  );

  return (
    <div className="admin-table-wrap">
      <table className="admin-table">
        <thead>
          <tr>
            <th>
              Name
            </th>
            <th>
              Title
            </th>
            <th>
              Email
            </th>
            <th>
              Location
            </th>
            <th>
              Twitter
            </th>
            <th>
              LinkedIn
            </th>
            <th>
              Phone
            </th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((row, index) => (
            <tr
              key={row.fullName}
             
            >
              <td className="admin-table-strong">
                {row.fullName}
              </td>
              <td>
                {row.title}
              </td>
              <td>
                {row.email}
              </td>
              <td>
                {row.location}
              </td>
              <td>
                <a
                  href={row.twitter}
                  className="text-blue-500 hover:underline transition-colors duration-300"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Link here
                </a>
              </td>
              <td>
                <a
                  href={row.linkedIn}
                  className="text-blue-500 hover:underline transition-colors duration-300"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Link here
                </a>
              </td>
              <td>
                {row.phone}
              </td>

            </tr>
          ))}
        </tbody>
      </table>
      
    </div>
  );
}
